export default "__VITE_ASSET__buDzTTUM__"